var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade-search"}},[(_vm.search_app_active)?_c('div',{staticClass:"header-sp__search-contents"},[_c('search-form'),_vm._v(" "),_c('search-suggestions')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }